<template>
  <div class="jg">
    <!-- Penyaring: gelanggang, tanggal, babak. Jenis (Semua/Tanding/Seni) datang dari induk. -->
    <div class="jg-saring">
      <label class="jg-saring__item">
        <span>Gelanggang</span>
        <select v-model="fArena" class="form-select">
          <option value="">Semua gelanggang</option>
          <option v-for="a in daftarArena" :key="a" :value="a">{{ a }}</option>
        </select>
      </label>
      <label class="jg-saring__item">
        <span>Tanggal</span>
        <select v-model="fTanggal" class="form-select">
          <option value="">Semua tanggal</option>
          <option v-for="t in daftarTanggal" :key="t" :value="t">{{ tglPanjang(t) }}</option>
        </select>
      </label>
      <label class="jg-saring__item">
        <span>Babak</span>
        <select v-model="fBabak" class="form-select">
          <option value="">Semua babak</option>
          <option v-for="b in daftarBabak" :key="b" :value="b">{{ b }}</option>
        </select>
      </label>
      <label class="jg-saring__item jg-saring__cari">
        <span>Cari</span>
        <input v-model.trim="fCari" class="form-control" type="search" placeholder="Nama atlet / kontingen" />
      </label>
      <button type="button" class="btn btn-danger jg-unduh" :disabled="!kelompok.length || mengunduh" @click="unduh()">
        <i class="bi bi-download"></i> {{ mengunduh ? 'Menyiapkan…' : 'Unduh PDF' }}
      </button>
    </div>
    <p class="jg-ket">
      Menampilkan <strong>{{ jumlahTampil }}</strong> partai
      <span v-if="labelSaring"> · {{ labelSaring }}</span>
    </p>

    <div v-if="memuat" class="text-center text-muted my-5">
      <div class="spinner-border" role="status"></div>
      <div class="mt-2">Memuat jadwal…</div>
    </div>
    <div v-else-if="galat" class="alert alert-danger my-4">{{ galat }}</div>
    <div v-else-if="!semuaBaris.length" class="text-center text-muted my-5">
      <h5>Belum ada jadwal pertandingan.</h5>
      <p class="mb-0">Jadwal muncul di sini setelah panitia menyusunnya.</p>
    </div>
    <div v-else-if="!kelompok.length" class="text-center text-muted my-5">
      <h5>Tidak ada partai yang cocok dengan penyaring.</h5>
      <button type="button" class="btn btn-outline-secondary mt-2" @click="reset">Tampilkan semua</button>
    </div>

    <div ref="cetak" class="jg-cetak">
      <div v-for="g in kelompok" :key="g.kunci" :ref="(el) => (blokRef[g.kunci] = el)" class="jg-blok bg-white">
        <!-- Header asli halaman jadwal -->
        <div class="row align-items-center mb-4 jg-kepala-web">
          <div class="col-3 col-md-3 text-start">
            <img src="@/assets/images/ipsi.png" alt="Logo IPSI" class="logo-ipsi" />
          </div>
          <div class="col-9 col-md-6 text-center">
            <h4 class="text-dark mb-2 text-uppercase fw-bold">JADWAL {{ g.arena }}</h4>
            <h4 class="text-dark mb-2 text-uppercase fw-bold">{{ g.turnamen }}</h4>
            <div class="text-dark text-uppercase fw-bold">{{ tglPanjang(g.tanggal) }}</div>
          </div>
          <div class="col-12 col-md-3 text-center text-md-end jg-tanpa-cetak mt-2 mt-md-0">
            <button class="btn btn-sm btn-outline-primary" @click="unduh(g)">
              <i class="bi bi-download me-1"></i> Download Schedule
            </button>
          </div>
        </div>

        <!-- Satu tabel per rangkaian jenis yang berurutan; kepala tabel mengikuti jenisnya -->
        <div v-for="seg in g.segmen" :key="seg.kunci" class="mb-4 table-responsive">
          <!-- TANDING: bentuk asli -->
          <table v-if="seg.tipe === 'tanding'" class="table table-striped">
            <thead>
              <tr class="table-sub-header">
                <th>Partai</th>
                <th>Babak</th>
                <th class="text-uppercase text-center">Kelas</th>
                <th class="text-uppercase text-center">Kategori Usia</th>
                <th>Pool</th>
                <th class="text-uppercase text-center red">Merah</th>
                <th class="text-uppercase text-center blue">Biru</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in seg.baris" :key="r.kunci">
                <td>{{ r.no }}</td>
                <td>{{ r.babak }}</td>
                <td class="text-center">{{ r.kelasSaja || '-' }}</td>
                <td class="text-center">{{ r.usia || '-' }}</td>
                <td>{{ r.pool }}</td>
                <td class="text-center">
                  <div class="text-center font-red" :class="{ 'jg-menunggu': r.merah.menunggu }">{{ r.merah.nama }}</div>
                  <div v-if="r.merah.kontingen" class="text-center text-success">{{ r.merah.kontingen }}</div>
                </td>
                <td class="text-center">
                  <div class="text-center font-blue" :class="{ 'jg-menunggu': r.biru.menunggu }">{{ r.biru.nama }}</div>
                  <div v-if="r.biru.kontingen" class="text-center text-success">{{ r.biru.kontingen }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- SENI BATTLE: bentuk asli -->
          <table v-else-if="seg.tipe === 'seni-battle'" class="table table-striped">
            <thead>
              <tr class="table-sub-header">
                <th>PARTAI</th>
                <th>Babak</th>
                <th>Kelas</th>
                <th class="text-center red">Merah</th>
                <th class="text-center blue">Biru</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in seg.baris" :key="r.kunci">
                <td>{{ r.no }}</td>
                <td class="text-uppercase">{{ r.babak }}</td>
                <td class="text-uppercase">{{ r.kelas }}</td>
                <td class="corner-red">
                  <div class="names" :class="{ 'jg-menunggu': r.merah.menunggu }">{{ r.merah.nama }}</div>
                  <div v-if="r.merah.kontingen" class="contingent">{{ r.merah.kontingen }}</div>
                </td>
                <td class="corner-blue">
                  <div class="names" :class="{ 'jg-menunggu': r.biru.menunggu }">{{ r.biru.nama }}</div>
                  <div v-if="r.biru.kontingen" class="contingent">{{ r.biru.kontingen }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- SENI NON-BATTLE: bentuk asli (per pool) -->
          <table v-else class="table table-striped table-seni-simetris">
            <thead>
              <tr>
                <th :colspan="2 + seg.kolomAtlet" class="text-center fw-bold text-uppercase table-header">{{ seg.judul }}</th>
              </tr>
              <tr class="table-sub-header">
                <th class="text-center">PARTAI</th>
                <th>Kontingen</th>
                <template v-if="seg.kolomAtlet > 1">
                  <th v-for="n in seg.kolomAtlet" :key="n">Atlet {{ n }}</th>
                </template>
                <th v-else>Nama Atlet</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in seg.baris" :key="r.kunci">
                <td class="text-center">{{ r.no }}</td>
                <td>{{ r.merah.kontingen || '-' }}</td>
                <td v-for="n in seg.kolomAtlet" :key="n">{{ r.atlet[n - 1] || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Tata letak PDF: padat, gaya cetak resmi. Dirender di luar layar hanya saat mengunduh. -->
    <div v-if="blokCetak.length" class="jgp-luar"><div ref="pdf" class="jgp">
      <div v-for="(g, gi) in blokCetak" :key="'p-' + g.kunci" class="jgp-blok" :class="{ 'jgp-putus': gi > 0 }">
        <div class="jgp-kepala">
          <img src="@/assets/images/ipsi.png" alt="IPSI" />
          <div>
            <div class="jgp-j1">JADWAL {{ g.arena }}</div>
            <div class="jgp-j1">{{ g.turnamen }}</div>
            <div class="jgp-j2">{{ tglPanjang(g.tanggal) }}</div>
          </div>
        </div>
        <template v-for="seg in g.segmen" :key="'p-' + seg.kunci">
          <table v-if="seg.tipe === 'tanding' || seg.tipe === 'seni-battle'" class="jgp-tabel">
            <thead>
              <tr>
                <th class="w-partai">PARTAI</th><th class="w-babak">BABAK</th><th>KELAS</th>
                <th v-if="seg.tipe === 'tanding'" class="w-pool">POOL</th>
                <th class="jgp-biru">SUDUT BIRU</th><th class="jgp-merah">SUDUT MERAH</th><th colspan="2" class="w-skor2">SCORE</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in seg.baris" :key="'p-' + r.kunci">
                <td>{{ r.no }}</td><td>{{ r.babak }}</td><td>{{ r.kelasCetak }}</td>
                <td v-if="seg.tipe === 'tanding'">{{ r.pool }}</td>
                <td><div class="t-biru" :class="{ 'jg-menunggu': r.biru.menunggu }">{{ r.biru.nama }}</div><div v-if="r.biru.kontingen" class="t-kont">{{ r.biru.kontingen }}</div></td>
                <td><div class="t-merah" :class="{ 'jg-menunggu': r.merah.menunggu }">{{ r.merah.nama }}</div><div v-if="r.merah.kontingen" class="t-kont">{{ r.merah.kontingen }}</div></td>
                <td class="w-skor1">-</td><td class="w-skor1">-</td>
              </tr>
            </tbody>
          </table>
          <table v-else class="jgp-tabel">
            <thead>
              <tr><th class="w-partai">PARTAI</th><th>KONTINGEN</th><th>NAMA ATLET</th><th class="w-skor">WAKTU</th><th class="w-skor">SCORE</th></tr>
              <tr><th colspan="5" class="jgp-judul">{{ seg.judul }}</th></tr>
            </thead>
            <tbody>
              <tr v-for="r in seg.baris" :key="'p-' + r.kunci">
                <td>{{ r.no }}</td><td>{{ r.merah.kontingen || '-' }}</td><td>{{ r.atlet.join(', ') || '-' }}</td><td>-</td><td>-</td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div></div>
  </div>
</template>

<script>
/**
 * Jadwal gabungan tanding + seni, diurutkan menurut nomor partai yang
 * disusun panitia (misal 1–4 seni, 5–7 tanding, 8–10 seni) per gelanggang
 * per tanggal. Penyaring jenis/gelanggang/tanggal/babak dapat digabung,
 * dan "Unduh PDF" mencetak persis apa yang sedang tampil.
 */
import axios from 'axios';
import html2pdf from 'html2pdf.js';

const MENUNGGU = 'Menunggu pemenang';

export default {
  name: 'ScheduleGabunganPage',
  props: {
    slug: { type: String, required: true },
    jenis: { type: String, default: 'semua' }, // semua | tanding | seni
  },
  data() {
    return {
      blokRef: {}, blokCetak: [], semuaBaris: [], memuat: true, galat: null, mengunduh: false,
      fArena: '', fTanggal: '', fBabak: '', fCari: '',
    };
  },
  computed: {
    barisJenis() {
      return this.jenis === 'semua' ? this.semuaBaris : this.semuaBaris.filter((r) => r.jenis === this.jenis);
    },
    daftarArena() { return [...new Set(this.barisJenis.map((r) => r.arena))].sort(); },
    daftarTanggal() { return [...new Set(this.barisJenis.map((r) => r.tanggal))].sort(); },
    daftarBabak() { return [...new Set(this.barisJenis.map((r) => r.babak).filter((b) => b && b !== '-'))]; },
    tersaring() {
      const k = this.fCari.toLowerCase();
      return this.barisJenis.filter((r) =>
        (!this.fArena || r.arena === this.fArena)
        && (!this.fTanggal || r.tanggal === this.fTanggal)
        && (!this.fBabak || r.babak === this.fBabak)
        && (!k || r.cari.includes(k)));
    },
    kelompok() {
      const peta = new Map();
      for (const r of this.tersaring) {
        const kunci = `${r.tanggal}|${r.arena}`;
        if (!peta.has(kunci)) peta.set(kunci, { kunci, tanggal: r.tanggal, arena: r.arena, turnamen: r.turnamen, baris: [] });
        peta.get(kunci).baris.push(r);
      }
      const hasil = [...peta.values()].sort((a, b) => (a.tanggal + a.arena).localeCompare(b.tanggal + b.arena));
      hasil.forEach((g) => {
        g.baris.sort((a, b) => (a.no - b.no) || a.jam.localeCompare(b.jam));
        // pecah jadi rangkaian berurutan dengan tipe tabel yang sama
        g.segmen = [];
        for (const r of g.baris) {
          const akhir = g.segmen[g.segmen.length - 1];
          const kunciTipe = r.tipe === 'seni-pool' ? `${r.tipe}|${r.kelompokPool}` : r.tipe;
          if (akhir && akhir.kunciTipe === kunciTipe) akhir.baris.push(r);
          else g.segmen.push({ kunci: `${g.kunci}-${g.segmen.length}`, kunciTipe, tipe: r.tipe, judul: r.judulPool, kolomAtlet: r.kolomAtlet || 1, baris: [r] });
        }
      });
      return hasil;
    },
    jumlahTampil() { return this.tersaring.length; },
    labelSaring() {
      return [this.fArena, this.fTanggal && this.tglPanjang(this.fTanggal), this.fBabak].filter(Boolean).join(' · ');
    },
  },
  watch: {
    jenis() {
      if (this.fArena && !this.daftarArena.includes(this.fArena)) this.fArena = '';
      if (this.fBabak && !this.daftarBabak.includes(this.fBabak)) this.fBabak = '';
    },
  },
  mounted() { this.muat(); },
  methods: {
    reset() { this.fArena = ''; this.fTanggal = ''; this.fBabak = ''; this.fCari = ''; },
    jam(t) { return t ? String(t).slice(0, 5) : '-'; },
    tglPanjang(d) {
      if (!d) return '-';
      return new Date(d).toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    },
    sisi(nama, kontingen) {
      const n = (nama || '').trim();
      const kosong = !n || /^(tbd|bye|-|null|pemenang babak sebelumnya)$/i.test(n);
      return { nama: kosong ? MENUNGGU : n, kontingen: kosong ? '' : (kontingen || ''), menunggu: kosong };
    },
    async muat() {
      this.memuat = true; this.galat = null;
      try {
        const [t, s] = await Promise.all([
          axios.get(`/tournaments/${this.slug}/match-schedules/tanding`).catch(() => ({ data: { data: [] } })),
          axios.get(`/tournaments/${this.slug}/match-schedules/seni`).catch(() => ({ data: { data: [] } })),
        ]);
        this.semuaBaris = [...this.olahTanding(t.data?.data || []), ...this.olahSeni(s.data?.data || [])];
      } catch (e) {
        this.galat = e?.response?.data?.message || 'Jadwal gagal dimuat.';
      } finally {
        this.memuat = false;
      }
    },
    olahTanding(data) {
      const out = [];
      for (const a of data) {
        for (const k of a.age_category_rounds || []) {
          for (const r of k.rounds || []) {
            for (const m of r.matches || []) {
              const no = Number(m.match_number || m.match_order) || 0;
              // participant_one = sudut biru, participant_two = sudut merah (konvensi halaman tanding)
              const biru = this.sisi(m.participant_one, m.contingent_one);
              const merah = this.sisi(m.participant_two, m.contingent_two);
              out.push({
                kunci: `t-${a.arena_name}-${a.scheduled_date}-${no}-${m.pool_id}`,
                jenis: 'tanding', no, jam: this.jam(m.match_time), arena: a.arena_name, tanggal: a.scheduled_date,
                turnamen: a.tournament_name, babak: m.round_label || r.round_label || '-',
                kelas: `${m.class_only || ''} ${m.age_category_name || ''} ${m.gender || ''}`.replace(/\s+/g, ' ').trim(),
                kelasCetak: `${m.age_category_name || ''} ${String(m.class_only || '').replace(/^kelas\s*/i, '')} (${m.gender || '-'})`.replace(/\s+/g, ' ').trim(),
                tipe: 'tanding', kelasSaja: m.class_only || m.class_name, usia: m.age_category_name, pool: this.namaPool(m.pool_name),
                merah, biru, tunggalTampil: false,
                cari: `${merah.nama} ${merah.kontingen} ${biru.nama} ${biru.kontingen}`.toLowerCase(),
              });
            }
          }
        }
      }
      return out;
    },
    namaPool(name) {
      if (!name || name === '-') return '-';
      const t = String(name).trim();
      const m = t.match(/^Pool\s+(\d+)$/i);
      if (m) { const n = parseInt(m[1], 10); if (n >= 1 && n <= 26) return 'Pool ' + String.fromCharCode(64 + n); }
      return t.split('-')[0].trim();
    },
    /** "TUNGGAL FULL KHUSUS PUTRA REMAJA" — nomor, jenis kelamin, lalu usia. */
    kelasSeni(g, m) {
      const jk = (m.gender || g.gender) === 'female' ? 'PUTRI' : 'PUTRA';
      const usia = g.age_category || m.pool?.age_category?.name || '';
      return `${g.category || m.category_name || ''} ${jk} ${usia}`.replace(/\s+/g, ' ').trim().toUpperCase();
    },
    namaSeni(m) {
      return [m.team_member1, m.team_member2, m.team_member3].filter(Boolean).map((x) => x.name || x).join(', ');
    },
    olahSeni(data) {
      const out = [];
      for (const a of data) {
        for (const g of a.groups || []) {
          for (const p of g.pools || []) {
            const battle = new Map();
            for (const m of p.matches || []) {
              const no = Number(m.match_order) || 0;
              const dasar = {
                jenis: 'seni', no, jam: this.jam(m.match_time), arena: a.arena_name, tanggal: a.scheduled_date,
                turnamen: a.tournament_name, babak: m.round_label || '-',
                kelas: this.kelasSeni(g, m), kelasCetak: this.kelasSeni(g, m),
              };
              const pihak = this.sisi(this.namaSeni(m), m.contingent?.name);
              if (pihak.menunggu && m.winner_of_order) pihak.nama = `Pemenang Partai ${m.winner_of_order}`;
              if (m.mode === 'battle') {
                const kunci = `${p.name}|${m.battle_group}|${no}`;
                if (!battle.has(kunci)) battle.set(kunci, { ...dasar, tipe: 'seni-battle', kunci: `s-${a.arena_name}-${a.scheduled_date}-${kunci}`, merah: this.sisi(''), biru: this.sisi(''), tunggalTampil: false });
                battle.get(kunci)[m.corner === 'red' ? 'merah' : 'biru'] = pihak;
              } else {
                const atlet = [m.team_member1, m.team_member2, m.team_member3].filter(Boolean).map((x) => x.name || x);
                const kolom = m.match_type === 'seni_regu' ? 3 : m.match_type === 'seni_ganda' ? 2 : 1;
                out.push({ ...dasar, tipe: 'seni-pool', kelompokPool: `${g.category}|${g.age_category}|${g.gender}|${p.name}`,
                  judulPool: `${this.kelasSeni(g, m)} - ${String(p.name || '').toUpperCase()}`, kolomAtlet: kolom, atlet,
                  kunci: `s-${m.id}`, merah: pihak, biru: this.sisi(''), tunggalTampil: true, cari: `${pihak.nama} ${pihak.kontingen}`.toLowerCase() });
              }
            }
            for (const r of battle.values()) {
              r.cari = `${r.merah.nama} ${r.merah.kontingen} ${r.biru.nama} ${r.biru.kontingen}`.toLowerCase();
              out.push(r);
            }
          }
        }
      }
      return out;
    },
    async unduh(blok) {
      this.mengunduh = true;
      const g = blok && blok.arena ? blok : null;
      const bagian = [this.slug, this.jenis !== 'semua' ? this.jenis : 'semua', g ? g.arena : this.fArena, g ? g.tanggal : this.fTanggal, this.fBabak]
        .filter(Boolean).join('-').toLowerCase().replace(/[^a-z0-9-]+/g, '-');
      this.blokCetak = g ? [g] : this.kelompok;
      await this.$nextTick();
      try {
        await html2pdf().set({
          filename: `jadwal-${bagian}.pdf`,
          margin: [10, 10, 10, 10],
          image: { type: 'jpeg', quality: 0.95 },
          html2canvas: { scale: 2, useCORS: true, windowWidth: 710, scrollX: 0, scrollY: 0 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: ['css', 'legacy'], before: '.jgp-putus', avoid: 'tr' },
        }).from(this.$refs.pdf).save();
      } finally {
        this.blokCetak = [];
        this.mengunduh = false;
      }
    },
  },
};
</script>

<style scoped>
.jg-saring { display: flex; flex-wrap: wrap; gap: .75rem; align-items: flex-end; margin-bottom: .5rem; }
.jg-saring__item { display: flex; flex-direction: column; gap: .25rem; flex: 1 1 170px; min-width: 150px; font-size: .85rem; font-weight: 600; margin: 0; }
.jg-saring__cari { flex: 2 1 220px; }
.jg-unduh { flex: 0 0 auto; white-space: nowrap; }
.jg-ket { font-size: .85rem; color: var(--text-muted, #6b7280); margin: 0 0 1rem; }
.jg-blok { padding: 1rem 0; margin-bottom: 1rem; }
.jgp-luar { position: fixed; left: -10000px; top: 0; }
.jgp { width: 710px; background: #fff; color: #222; font-family: Arial, Helvetica, sans-serif; }
.jgp-blok { padding: 6px 4px; }
.jgp-kepala { display: grid; grid-template-columns: 110px 1fr 110px; align-items: center; margin: 4px 0 16px; text-align: center; }
.jgp-kepala img { width: 92px; }
.jgp-j1 { font-size: 19px; font-weight: 700; line-height: 1.25; text-transform: uppercase; }
.jgp-j2 { font-size: 12px; font-weight: 700; text-transform: uppercase; margin-top: 2px; }
.jgp-tabel { width: 100%; border-collapse: collapse; font-size: 10.5px; margin-bottom: 14px; }
.jgp-tabel th { background: #4a4f55; color: #fff; font-weight: 700; padding: 10px 6px; text-align: center; border-bottom: 1px solid #fff; }
.jgp-tabel th.jgp-biru { background: #0033cc; }
.jgp-tabel th.jgp-merah { background: #ff0000; }
.jgp-tabel th.jgp-judul { background: #34383d; padding: 7px 6px; }
.jgp-tabel td { padding: 6px; text-align: center; border-bottom: 1px solid #e3e3e3; vertical-align: middle; }
.jgp-tabel tbody tr:nth-child(even) td { background: #f3f3f3; }
.w-partai { width: 52px; } .w-babak { width: 74px; } .w-pool { width: 52px; } .w-skor { width: 54px; } .w-skor2 { width: 84px; } .w-skor1 { width: 42px; }
.t-biru { color: #1a73e8; } .t-merah { color: #e0303a; } .t-kont { color: #1e9e3a; }
@media (max-width: 640px) {
  .jg-kepala-web h4 { font-size: 1rem; }
  .jg-blok .table { min-width: 560px; font-size: .8rem; }
}
.jg-menunggu { font-style: italic; font-weight: 400 !important; opacity: .85; }
</style>
